import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {TARMAC, CHARCOAL} from '../../../style/colors';
import glamorous from 'glamorous';
import {PHONE} from '../../../style/breakpoints';
import {MOBILE_PADDING} from '../card';
import VulnerabilityChip from '../../../../bundles/company-dashboard/components/vulnerability/chip';

const DESKTOP_MARGIN = 45;
const MOBILE_MARGIN = 25;

const Container = glamorous.div({
  display: 'block',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  [PHONE]: {
    padding: MOBILE_PADDING,
    paddingLeft: 5,
    paddingRight: 0,
    width: '100%'
  },
  ' > div > div': {
    marginLeft: DESKTOP_MARGIN,
    [PHONE]: {
      marginLeft: MOBILE_MARGIN
    }
  }
});

const VulnerabilityTitle = glamorous.div({
  fontSize: 13,
  color: TARMAC,
  marginRight: 5,
  marginTop: 10,
  [PHONE]: {
    marginLeft: 2,
    marginBottom: 2
  }
});

const VulnerabilityContent = glamorous.div({
  display: 'flex',
  [PHONE]: {
    display: 'block'
  }
});

const Placeholder = glamorous.div({
  ...BASE_TEXT,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontsize: 14,
  color: TARMAC,
  fontStyle: 'italic',
  textAlign: 'center'
});

const List = glamorous.ul({
  margin: 0,
  padding: 0
});

const ListItem = glamorous.li({
  ...BASE_TEXT,
  color: CHARCOAL,
  fontSize: 15,
  display: 'flex',
  '&::before': {
    content: '\u2022',
    padding: '9px 10px 0 5px'
  }
});

const StackupsVulnerabilities = ({vulnerabilities, placeholder = 'No Vulnerabilities found'}) => {
  return (
    <Container>
      {vulnerabilities.length > 0 ? (
        <>
          {vulnerabilities.slice(0, 3).map(item => (
            <List key={item.node.id}>
              <ListItem>
                <VulnerabilityContent>
                  <VulnerabilityTitle>{item.node.name}</VulnerabilityTitle>
                  <VulnerabilityChip
                    item={item.node.severity}
                    extraStyle={{
                      marginLeft: 0
                    }}
                  />
                </VulnerabilityContent>
              </ListItem>
            </List>
          ))}
        </>
      ) : (
        <Placeholder>{placeholder}</Placeholder>
      )}
    </Container>
  );
};

StackupsVulnerabilities.propTypes = {
  vulnerabilities: PropTypes.object,
  placeholder: PropTypes.string
};

export default StackupsVulnerabilities;
